<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <!-- <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">ข้อมูลนำเข้า</v-card-title> -->
      <v-card-title class="px-0 pb-0" style="font-weight: bold;  font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ข้อมูลนำเข้า
        <span>
          <v-chip small class="ma-2" :color="status === 'success' ? '#F0F9EE' : '#F7D9D9'" :text-color="status === 'success' ? '#1AB759' : '#F5222D'" style="font-weight: normal">{{ status === 'success' ? 'นำเข้าข้อมูลสำเร็จ' : 'นำเข้าข้อมูลไม่สำเร็จ'}}</v-chip>
        </span>
      </v-card-title>
      <v-card-title class="px-0 pb-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ข้อมูลนำเข้า
        <span>
          <v-chip small class="ma-2" :color="status === 'success' ? '#F0F9EE' : '#F7D9D9'" :text-color="status === 'success' ? '#1AB759' : '#F5222D'" style="font-weight: normal">{{ status === 'success' ? 'นำเข้าข้อมูลสำเร็จ' : 'นำเข้าข้อมูลไม่สำเร็จ'}}</v-chip>
      </span>
      </v-card-title>
    </v-card>
    <v-card-text class="pt-0">
      <v-row no-gutters>
        <v-row v-if="(MobileSize || IpadSize)" :class="MobileSize || IpadSize || IpadProSize ? 'mt-1' : 'my-3'">
          <v-col cols="12" class="pt-2 pb-0" align="end">
            <v-btn v-if="status === 'fail'" width="101" class="ml-1" color="#27AB9C" outlined @click="$refs.file_input.click()"><v-icon small>mdi-plus</v-icon>เพิ่มข้อมูล</v-btn>
            <input type="file" @click="event => event.target.value = null" @change="previewFiles($event)" ref="file_input" style="display: none;"/>
          </v-col>
          <v-col cols="12" class="pt-3 pb-0">
            <v-row dense>
              <v-col :cols="12" class="pt-2">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการเพิ่มข้อมูลลูกค้าทั้งหมด {{ showCountImportcustomer }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else :class="MobileSize || IpadSize || IpadProSize ? 'mt-1' : 'my-3'">
          <v-col :cols="MobileSize || IpadSize || IpadProSize ? 12 : 9" class="pt-3 pb-0">
            <v-row dense>
              <v-col :cols="12" class="pt-2">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการเพิ่มข้อมูลลูกค้าทั้งหมด {{ showCountImportcustomer }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col :cols="MobileSize || IpadSize ? 12 : 3" align="end" class="pt-2 pb-0">
            <v-btn v-if="status === 'fail'" width="101" class="ml-1" color="#27AB9C" outlined @click="$refs.file_input.click()"><v-icon small>mdi-plus</v-icon>เพิ่มข้อมูล</v-btn>
            <input type="file" @click="event => event.target.value = null" @change="previewFiles($event)" ref="file_input" style="display: none;"/>
          </v-col>
        </v-row>
        <v-col cols="12" v-if="disableTable === false">
          <v-data-table
          :headers="headers"
          :items="importcustomerList"
          style="width:100%;"
          height="100%"
          :page.sync="page"
          @pagination="countCustomer"
          no-results-text="ไม่พบรายชื่อลูกค้า"
          no-data-text="ไม่มีรายชื่อลูกค้าในตาราง"
          :footer-props="{'items-per-page-text':'จำนวนแถว'}"
          @update:items-per-page="itemsPerPage"
          :items-per-page="10"
          class="elevation-1 mt-4"
          >
            <template v-slot:[`item.no`]="{ item, index }">
              {{ item.no ? item.no : index + 1 }}
            </template>
            <template v-slot:[`item.data_check`]="{ item }">
              <span v-if="item.data_check === '-'">{{ item.data_check }}</span>
              <span v-else style="color: #F5222D;">{{ item.data_check }}</span>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" v-else>
          <v-row justify="center" align-content="center">
            <v-col cols="12" md="12" align="center">
              <div class="my-5">
                <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
              </div>
              <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายชื่อลูกค้า</b></h2>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <ModalManageCustomerData ref="ModalManageCustomerData" />
  </v-container>
</template>
<script>
import { Decode, Encode } from '@/services'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  components: {
    ModalManageCustomerData: () => import('@/components/Gracz/Admin/Customer/Modal/ManageCustomerDataModal')
  },
  data () {
    return {
      status: '',
      statusCanCreate: false,
      showCountImportcustomer: 0,
      pageCount: 5,
      page: 1,
      itemsPerPage: 10,
      importcustomerList: [],
      disableTable: true,
      headers: [
        { text: 'ที่', value: 'no', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'รหัสลูกค้า', value: 'cus_code', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'เบอร์ติดต่อ', value: 'cus_tel', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'กลุ่มลูกค้า', value: 'channel_name', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'emp_code', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'หมายเหตุ', value: 'note', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'การตรวจสอบข้อมูล', value: 'data_check', sortable: false, class: 'backgroundTable fontTable--text' }
      ],
      userDetailSelling: '',
      customerData: '',
      importCustomer: [],
      file: null
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/ImportCustomerDataMobile').catch(() => {})
      } else {
        this.$router.push('/Order/ImportCustomerData').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.getData()
    }
  },
  methods: {
    previewFiles (e) {
      var files = e.target.files
      var f = files[0]
      // var dataJ
      var reader = new FileReader()
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        /* DO SOMETHING WITH workbook HERE */
        const worksheet = workbook.Sheets[sheetName]
        this.importCustomerData(XLSX.utils.sheet_to_json(worksheet))
      }
      reader.readAsArrayBuffer(f)
    },
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push('/Order/CustomerListMobile').catch(() => {})
      } else {
        this.$router.push('/Order/CustomerList').catch(() => {})
      }
    },
    getData () {
      if (localStorage.getItem('previewCheckImportCustomer') !== undefined && localStorage.getItem('previewCheckImportCustomer') !== null) {
        var previewCheckImportCustomer = JSON.parse(Decode.decode(localStorage.getItem('previewCheckImportCustomer')))
        this.importcustomerList = previewCheckImportCustomer.data
        if (previewCheckImportCustomer.response === 'Fail to upload customer data from excel file.') {
          this.status = 'fail'
        } else if (previewCheckImportCustomer.response === 'Create customer data from excel file successfully.') {
          this.status = 'success'
        }
        if (this.importcustomerList.length !== 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      }
    },
    onPickFile () {
      document.getElementById('file_input').click()
    },
    uploadExcel () {
      this.importCustomerData()
    },
    async importCustomerData (excelJson) {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      var sendData
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        file: excelJson
      }
      await this.$store.dispatch('actionsGraczImportCustomerData', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczImportCustomerData
      if (response.code !== 500) {
        if (response.message === 'Create customer data from excel file successfully.') {
          this.$store.commit('closeLoader')
          this.status = 'success'
          this.importcustomerList = response.data
          if (this.importcustomerList.length !== 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
          this.showCountImportcustomer = response.data.length
          this.$swal.fire({ icon: 'success', text: 'นำเข้าข้อมูลลูกค้าจากไฟล์ Excel สำเร็จ', showConfirmButton: false, timer: 2000 })
        } else if (response.message === 'Fail to upload customer data from excel file.') {
          this.$store.commit('closeLoader')
          this.status = 'fail'
          this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
          this.importcustomerList = response.data
          if (this.importcustomerList.length !== 0) {
            this.disableTable = false
          } else {
            this.disableTable = true
          }
          this.showCountImportcustomer = response.data.length
          sendData = {
            response: response.message,
            data: response.data
          }
          await localStorage.setItem('previewCheckImportCustomer', Encode.encode(sendData))
        } else {
          this.$store.commit('closeLoader')
          if (response.message === 'This user is unauthorized.') {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else if (response.message === 'Not access this function.') {
            this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else {
            var [msg, iconMsg] = this.getErrorMsg(response.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          }
        }
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === 'Fail to upload file.') {
        return ['ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ได้ ', 'warning']
      } else if (msg === 'Data have not more than 400') {
        return ['ไม่สามารถนำเข้าข้อมูลลูกค้าที่มากกว่า 400 รายการได้', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    countCustomer (pagination) {
      this.showCountImportcustomer = pagination.itemsLength
    }
  }
}
</script>
<style scoped>
</style>
